export enum CopyType {
  Copy = `copy`,
  Link = `link`,
}

export type CopyOption = {
  value: string;
  label?: string;
};
